
/*
All routes in this file are related to the admin login portion of the portal
all routes use the dynamic import method, when creating a new route be sure
to include the meta: { requiressAuth: true, roles:['admin']}

Clients will not have access to this portion of the site
*/

const AdminRoutes = [
  {
    path: '/admin',
    name: 'admin',
    component: () => import('@/views/admin/AdminView'),
    meta: { requiresAuth: true, roles: ['admin'] }
  },
  {
    path: '/requestors',
    name: 'requestors',
    component: () => import('@/views/admin/RequestorManager.vue'),
    meta: { requiresAuth: true, roles: ['admin'] }
  },
  {
    path: '/accounts/:ownerId',
    name: 'account',
    component: () => import('@/views/admin/AccountManager'),
    meta: { requiresAuth: true, roles: ['admin'] }
  },
  {
    path: '/lpadmins',
    name: 'lpadmins',
    component: () => import('@/views/admin/LpUserManager'),
    meta: { requiresAuth: true, roles: ['admin'] }
  },
  {
    path: '/accounts',
    name: 'accounts',
    component: () => import('@/views/admin/AccountManager'),
    meta: { requiresAuth: true, roles: ['admin'] }
  }
]

export default AdminRoutes